var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "transparent-header" }, [
    _c("div", {
      staticClass: "mask",
      style: {
        backgroundColor: _vm.color,
        opacity: _vm.customOpacity || _vm.opacity,
      },
    }),
    _c(
      "div",
      { staticClass: "page-header-con" },
      [
        _vm._t("left-back", function () {
          return [
            _c(
              "div",
              { staticClass: "back-btn", on: { click: _vm.pageBack } },
              [
                !_vm.switchType
                  ? _c("div", {
                      staticClass: "btn",
                      class: [`btn${_vm.type}`],
                      style: { backgroundColor: _vm.pageBackBg },
                    })
                  : _c("div", {
                      staticClass: "btn",
                      class: [
                        `btn${_vm.opacity < _vm.switchThreshold ? 1 : 2}`,
                      ],
                    }),
              ]
            ),
          ]
        }),
        _c(
          "div",
          {
            staticClass: "page-title",
            style: {
              color: _vm.titleColor,
              opacity: _vm.titleCustomOpacity
                ? _vm.titleCustomOpacity
                : _vm.customOpacity || _vm.opacity,
            },
          },
          [
            _vm._t("title", function () {
              return [
                _vm._v(" " + _vm._s(_vm.pageTitle || _vm.defaultTitle) + " "),
              ]
            }),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "right-btn" },
          [
            _vm._t(
              "right-btn",
              function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "opt-btn-wrap",
                      class: [
                        { type1: !_vm.switchType && _vm.type == 1 },
                        { type2: !_vm.switchType && _vm.type == 2 },
                        {
                          type1:
                            _vm.switchType && _vm.opacity < _vm.switchThreshold,
                        },
                        {
                          type2:
                            _vm.switchType &&
                            _vm.opacity >= _vm.switchThreshold,
                        },
                      ],
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "refresh-btn",
                          on: { click: _vm.pageRefresh },
                        },
                        [
                          !_vm.switchType
                            ? _c("div", {
                                staticClass: "btn",
                                class: [`btn${_vm.type}`],
                              })
                            : _c("div", {
                                staticClass: "btn",
                                class: [
                                  `btn${
                                    _vm.opacity < _vm.switchThreshold ? 1 : 2
                                  }`,
                                ],
                              }),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "close-btn",
                          on: { click: _vm.pageClose },
                        },
                        [
                          !_vm.switchType
                            ? _c("div", {
                                staticClass: "btn",
                                class: [`btn${_vm.type}`],
                              })
                            : _c("div", {
                                staticClass: "btn",
                                class: [
                                  `btn${
                                    _vm.opacity < _vm.switchThreshold ? 1 : 2
                                  }`,
                                ],
                              }),
                        ]
                      ),
                    ]
                  ),
                ]
              },
              {
                data: {
                  opacity: _vm.opacity,
                  switchThreshold: _vm.switchThreshold,
                },
              }
            ),
          ],
          2
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }